/* global Highcharts */

(function () {
  'use strict';

  var id = 'heatmap',
    heatmapMeasures = null;

  // Add onto the wsLrs.cards module...
  angular.module('wsLrs.cards').factory(id + '.Utils', ['$filter', 'AggregationUtils', 'CardQueryResource', 'ChartUtils', 'Utils', id + '.AdvancedColors', 'QueryES', 'wsColors', '$sanitize', function ($filter, AggUtils, CardQueryResource, ChartUtils, Utils, AdvancedColors, QueryES, wsColors, $sanitize) {
    // this expands the clipBox by 2 pixels all around to accommodate the cell hover border highlighting
    Highcharts.wrap(Highcharts.Chart.prototype, 'setChartSize', function (proceed) {
      proceed.apply(this, [].slice.call(arguments, 1));
      this.clipBox.x -= 2;
      this.clipBox.y -= 2;
      this.clipBox.height += 4;
      this.clipBox.width += 4;
    });

    // this adjusts the position of x-axis labels on the top of the chart (opposite)
    Highcharts.wrap(Highcharts.Tick.prototype, 'getLabelPosition', function (proceed) {
      var args = [].slice.call(arguments, 1),
        y = args[1],
        label = args[2],
        horiz = args[3],
        yOffset = args[4].y,
        axis = this.axis,
        rotCorr = axis.tickRotCorr || {
          x: 0,
          y: 0
        };
      var ret = proceed.apply(this, args);
      if (horiz && axis.opposite && !axis.labelRotation) {
        var bBoxH = label.getBBox().height;
        ret.y = Math.round(y + (yOffset === null ? rotCorr.y : yOffset) - bBoxH);
      }
      return ret;
    });
    function getVisibleMeasures(config) {
      if (config.hiddenMeasures) {
        var visibleMeasures = [];
        _.each(config.measures, function (measure, i) {
          // Hidden measures is an array measures by index which is why we iterate here with i
          // and see if i is in the hiddenMeasures array
          if (!_.contains(config.hiddenMeasures, i)) {
            visibleMeasures.push(measure);
          }
        });
        return visibleMeasures;
      } else {
        return config.measures;
      }
    }
    function getVisibleMeasureIndex(config) {
      return Array.isArray(config.hiddenMeasures) ? Array.from(config.measures, function (_, i) {
        return i;
      }).filter(function (i) {
        return !config.hiddenMeasures.includes(i);
      }) : [];
    }
    var POINT_LABEL_PROPS = {
      DEFAULT_TEXT: ' -- ',
      FONT_SIZE: 12,
      LINE_SPACING: 2,
      CHAR_WIDTH: 7
    };
    POINT_LABEL_PROPS.LINE_HEIGHT = function () {
      return POINT_LABEL_PROPS.FONT_SIZE + POINT_LABEL_PROPS.LINE_SPACING;
    };
    return {
      getVisibleMeasures: getVisibleMeasures,
      getVisibleMeasureIndex: getVisibleMeasureIndex,
      fetchData: function fetchData(cfg) {
        cfg = cfg || {};
        var path = "/heatmap/data",
          params = cfg.params;

        // Special case for preview, to minimize number of preview requests,
        // make this agree with detail preview query...
        if (cfg.cardToPreview) {
          params = {
            "_limit": Utils._try(function () {
              return cfg.params._limit || 10;
            }, 10),
            "_offset": Utils._try(function () {
              return cfg.params._offset || 0;
            }, 0)
          };
          if (cfg.params && cfg.params.numMeasuresToDisplay) {
            params.numMeasuresToDisplay = cfg.params.numMeasuresToDisplay;
          }
        }
        return CardQueryResource.getWithProgress(path, cfg.cardId, params, cfg.cardToPreview, 'heatmap-' + cfg.cardId);
      },
      getStatementDownloadUrl: function getStatementDownloadUrl(cardId) {
        return QueryES.queryExportUrl(cardId, true, id);
      },
      // todo: add a 'normalize' flag. if it's 'false' just return the value as is
      getHeatmapColorValue: function getHeatmapColorValue(m, minMax) {
        var normalize = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;
        if (!!m && !normalize) {
          return m.value;
        }
        //return a new value from 0 to 100 for each measure based on the min and max for that measure
        if (!m || _.isNull(m.value) || _.isUndefined(m.value)) {
          return -0.01;
        }
        minMax = minMax || {};
        // if the range is 0, all values = avg value.  Use 50.
        if (minMax.min === minMax.max) {
          return 50;
        }
        var min = minMax.min < 0 ? minMax.min : 0;
        var value = 100 * (m.value - min) / (minMax.max - min);
        return value;
      },
      getHeatmapChart: function getHeatmapChart(data, config, stats, options, visibleMeasureIndex) {
        var empty = ChartUtils.getEmptyChart();
        if (!data || data.length === 0) {
          return empty;
        }
        var chart = {
            credits: {
              enabled: false
            },
            chart: {
              type: 'heatmap',
              plotBorderWidth: 2,
              plotBorderColor: 'white',
              spacingTop: 20 // spacing adjusts to labels (while margin does not)
            },
            title: {
              text: ''
            },
            colorAxis: AdvancedColors.getColorAxis(config),
            // prevent hover from changing cell color
            colors: [null],
            xAxis: {
              //columns, the measures go here
              categories: $filter('truncate')(_.pluck(config.measures, 'name'), 100),
              names: _.pluck(config.measures, 'name'),
              id: 'xAxis',
              labels: {
                style: {
                  fill: '#333',
                  fontSize: '12px',
                  fontWeight: 'normal'
                },
                y: null,
                autoRotation: [-90],
                formatter: function formatter() {
                  var maxLength = 100;
                  var tooLong = this.value.length > maxLength;
                  return "".concat(tooLong ? this.value.substring(0, maxLength) : this.value).concat(tooLong ? '...' : '');
                }
              },
              lineColor: '#FFF',
              tickColor: '#FFF',
              opposite: true
            },
            yAxis: {
              //rows, the dimensions go here
              categories: [],
              names: [],
              title: null,
              reversed: true,
              labels: {
                useHTML: true,
                style: {
                  fill: '#333',
                  fontSize: '12px',
                  fontWeight: 'normal',
                  textAlign: 'right'
                }
              }
            },
            legend: {
              enabled: false
            },
            tooltip: {
              formatter: function formatter() {
                return '<div class="watershed-tooltip" ><table><thead><tr><th>' + $sanitize(this.series.yAxis.options.names[this.point.y]) + '</th></tr></thead>' + '<tr><td>' + $sanitize(this.series.xAxis.options.names[this.point.x]) + ':</td>' + '<td>' + Utils.wordWrap(this.point.displayValue || ' -- ', 43) + '</td></tr>' + '</table></div>';
              }
            },
            series: [{
              name: '',
              borderColor: '#FFF',
              borderWidth: 2,
              data: [],
              dataLabels: {
                enabled: options.showValues,
                useHtml: true,
                formatter: function formatter() {
                  var text = Utils.decodeHtmlEntity(this.point.displayValue || POINT_LABEL_PROPS.DEFAULT_TEXT);
                  // rough estimate of how many pixels per line
                  // all of this because we can't use word-wrap in svg
                  var width = this.point.shapeArgs.width / POINT_LABEL_PROPS.CHAR_WIDTH;
                  // we also want to show only as many lines as will fit the cell
                  // associated with this point
                  // note:
                  //  we sub 1 from the shape-height bc if the text falls on the
                  //  boundary of the rect it's on, it'll interfere with the text on
                  //  the rect below
                  var height = Math.floor((this.point.shapeArgs.height - 1) / POINT_LABEL_PROPS.LINE_HEIGHT());
                  return Utils.wordWrap(text, width, height);
                },
                style: {
                  color: wsColors.getRGBA(wsColors.wsBlack, 0.9),
                  fontWeight: 'normal',
                  fontSize: "".concat(POINT_LABEL_PROPS.FONT_SIZE, "px"),
                  lineHeight: "".concat(POINT_LABEL_PROPS.LINE_HEIGHT(), "px"),
                  textShadow: 'none',
                  textOutline: '0px',
                  textAlign: 'center',
                  HcTextStroke: null
                }
              },
              point: {
                // move cell to front so hover border looks right
                events: {
                  mouseOver: function mouseOver() {
                    this.graphic.toFront();
                  }
                }
              },
              states: {
                // change border color (but not color/brightness) on hover
                hover: {
                  enabled: true,
                  brightness: 0,
                  borderColor: '#333',
                  borderWidth: 1
                }
              }
            }]
          },
          self = this;
        var row = 0;
        var globalMinMax = {
          min: _.min(_.pluck(stats, 'min')),
          max: _.max(_.pluck(stats, 'max'))
        };
        _.each(data, function (v) {
          var dimension = AggUtils.getDimensionDisplay(v.values[0], config.dimensions[0]);
          chart.yAxis.names.push(dimension);
          chart.yAxis.categories.push(ChartUtils.formatCategories(dimension, 24, 2, 2));

          // gather relevant info and materials for each aggregation
          var measureInfo = v.aggregations.map(function (aggregation, i) {
            var col = visibleMeasureIndex.findIndex(function (j) {
              return i === j;
            });
            var isHidden = col < 0;
            var x = {
              aggregation: aggregation,
              isHidden: isHidden
            };
            if (!isHidden) {
              x.col = col;
              x.stats = stats[i] || null;
              x.measure = config.measures[col];
            }
            return x;
          });
          measureInfo.forEach(function (m) {
            if (m.isHidden) {
              return;
            }
            var valueProducer = m.aggregation.type === 'ListAggregation' ?
            // if timeline, create a fake producer
            {
              valueProducer: {
                type: 'STATEMENT_PROPERTY',
                statementProperty: null
              }
            } : m.measure;
            var colorStats = config.scaleColorsGlobaly ? globalMinMax : m.stats;
            if (colorStats && m.measure) {
              colorStats.min = Utils._try(function () {
                return m.measure.min.value;
              }, colorStats.min);
              colorStats.max = Utils._try(function () {
                return m.measure.max.value;
              }, colorStats.max);
            }
            // note: 'value' is normalized, but the values in an 'advancedColors' expression refer
            //  to the non-normalized values ('displayValue')
            var nonShadedValue = config.colors && config.colors.length > 0 ? -1 : 0;
            chart.series[0].data.push({
              x: m.col,
              y: row,
              value: config.nonShadedMeasures && config.nonShadedMeasures.includes(m.col) ? nonShadedValue : self.getHeatmapColorValue(m.aggregation, colorStats, !AdvancedColors.configuredForAdvancedColorStops(config)),
              displayValue: AggUtils.getMeasureValueDisplay(m.aggregation, valueProducer)
            });
          });
          row++;
        });
        if (chart.series[0].data.length > (chart.series[0].turboThreshold || 1000)) {
          chart.series[0].turboThreshold = chart.series[0].data.length;
        }
        return chart;
      }
    };
  }]).config(['$routeProvider', function ($routeProvider) {
    // Add routes
    $routeProvider.
    //route format MUST be: card.template.name + "/" + card.id
    when('/heatmap/:cardId', {
      templateUrl: 'modules/app/heatmap/heatmap-detail.html',
      controller: id + ".Detail",
      resolve: {
        cardLoader: ['CardLoader', function (CardLoader) {
          return CardLoader.loadCards();
        }]
      }
    }).when('/heatmap/:cardId/top', {
      templateUrl: 'modules/app/heatmap/heatmap-card.html',
      resolve: {
        cardLoader: ['CardLoader', function (CardLoader) {
          return CardLoader.loadCards();
        }]
      }
    });
  }]).run(['CardIconMap', function (CardIconMap) {
    //Register card icon preferences ONLY IF different than default icon for card type
    CardIconMap.register({
      "heatmap": "heatmap"
    });
  }]).controller(id + ".CardConfiguration", ["$scope", '$controller', '$rootScope', function ($scope, $controller, $rootScope) {
    $scope.tempMeasures = heatmapMeasures;
    $scope.templateType = id;
    $controller("AggregationCardConfiguration", {
      $scope: $scope
    });
    $scope.heatmapHelpText = {
      helpTitle: 'Heatmap',
      detailText: "In the Heatmap section, you'll choose how you want to group data (in the Organized menu) " + "and what measures you'll want to see (using the Measures menu). Choose an option in the Organized " + "menu first, and then select as many measures as you'd like by choosing them in the dropdown and " + "clicking Add Measure. Remove a measure by clicking the X next to a selected measure. The Value Labels " + "option allows you to choose whether you want to hide or show numbers (or give end users the decision " + "by choosing Select in UI)."
    };
    if (_.isUndefined($scope.workingConfig.version)) {
      $scope.workingConfig.showValues = true;
    }
    $scope.setShowValues = function (val) {
      $scope.workingConfig.showValues = val;
      $scope.updateCardWithWorkingConfig();
    };
    $scope.setScaleColors = function (isGlobal) {
      $scope.workingConfig.scaleColorsGlobaly = isGlobal;
      $scope.updateCardWithWorkingConfig();
    };

    //clear out any heatmapMeasures on a new explore card event
    $rootScope.$on('explore-card', function () {
      heatmapMeasures = null;
    });
  }]).controller(id + ".Card", ["$scope", "CardRegistry", id + '.Utils', 'Utils', 'AggregationUtils', 'wsEventNames', '$routeParams', 'CardDisplay', 'ReportValidationService', function ($scope, CardRegistry, HeatmapUtils, Utils, AggUtils, wsEvents, $routeParams, CardDisplay, ReportValidationService) {
    // For use with /top route when embedding
    if (!$scope.cardId && $routeParams.cardId) {
      $scope.cardId = $routeParams.cardId;
    }
    $scope.config = angular.copy(CardRegistry.get($scope.cardId).configuration);
    $scope.visibleMeasureIndex = HeatmapUtils.getVisibleMeasureIndex($scope.config);
    $scope.config.measures = HeatmapUtils.getVisibleMeasures($scope.config);
    $scope.measures = angular.copy($scope.config.measures);
    $scope.defaultSummary = 'Heatmap of measures organized by ' + AggUtils.getDimensionInSentence($scope.config.dimensions[0], true) + '.';
    $scope.getMeasureValueDisplay = AggUtils.getMeasureValueDisplay;
    var validation = ReportValidationService.validate($scope.cardId);
    if (validation.hasErrors) {
      $scope.hasData = false;
      $scope.noDataMsg = validation.message;
      return;
    }
    var hasDefaultSort = Utils._try(function () {
      return $scope.config.defaultSort || false;
    }, false);
    $scope.fetchCfg = {
      cardId: $scope.cardId,
      cardToPreview: $scope.cardToPreview,
      params: {
        _limit: CardDisplay.getLimitParam($scope.cardId),
        order_by: hasDefaultSort || null,
        numMeasuresToDisplay: 10
      }
    };
    $scope.options = {
      showValues: angular.isDefined($scope.config.showValues) ? $scope.config.showValues : false
    };

    // Determine if we should hide the labels on the heatmap
    if ($scope.hideValues) {
      $scope.options.showValues = false;
    }
    var updateHeatmap = function updateHeatmap(pageData) {
      $scope.pageData = pageData || $scope.pageData;
      $scope.heatmapChart = HeatmapUtils.getHeatmapChart($scope.pageData, $scope.config, $scope.stats, $scope.options, $scope.visibleMeasureIndex);
      var chartRows = $scope.heatmapChart.yAxis ? $scope.heatmapChart.yAxis.categories.length : 1;
      // add additional amount (estimated) to account for axis/label height
      var measureCount = $scope.config.measures.length;
      var estAxisLabelHeight = measureCount > 12 ? 250 : 100;
      $scope.chartHeight = 40 * chartRows + estAxisLabelHeight + 'px';
    };
    HeatmapUtils.fetchData($scope.fetchCfg).then(function (data) {
      // Advertise that the preview loaded, with the preview data
      if ($scope.cardToPreview) {
        $scope.$emit(wsEvents.card.preview.loaded, data);
      }
      var results = data.results[0].result;
      var resultColumnsCount = results.data[0].aggregations.length;
      var measuresToDisplay = $scope.fetchCfg.params.numMeasuresToDisplay;
      var hiddenMeasuresCount = Utils.getIn($scope, 'config.hiddenMeasures.length', {
        alt: 0
      });
      var expectedColumnCount = measuresToDisplay + hiddenMeasuresCount;
      if (resultColumnsCount === expectedColumnCount + 1) {
        $scope.config.hiddenMeasures.push(resultColumnsCount - 1);
      }
      $scope.hasData = results.data.length > 0;
      $scope.stats = results.stats;
      $scope.pageData = results.data;
      updateHeatmap(results.data);
    }, function () {
      $scope.hasData = false;
    });
  }]).controller(id + ".Detail", ["$scope", "$routeParams", '$timeout', 'AggregationUtils', 'ReportValidationService', "CardRegistry", "CardUtils", id + '.Utils', 'wsEventNames', 'CardQueryResource', function ($scope, $routeParams, $timeout, AggUtils, ReportValidationService, CardRegistry, CardUtils, Utils, wsEventNames, CardQueryResource) {
    $scope.cardId = $routeParams.cardId;
    $scope.card = CardRegistry.get($scope.cardId);
    $scope.config = angular.copy($scope.card.configuration);
    $scope.visibleMeasureIndex = Utils.getVisibleMeasureIndex($scope.config);
    $scope.config.measures = Utils.getVisibleMeasures($scope.config);
    var validation = ReportValidationService.validate($scope.cardId);
    if (validation.hasErrors) {
      $scope.hasData = false;
      $scope.noDataMsg = validation.message;
      return;
    }

    // display options: showValues, hideEmptyRows (coming soon)
    $scope.options = {
      showValues: angular.isDefined($scope.config.showValues) ? $scope.config.showValues : false
    };
    var updateHeatmap = function updateHeatmap(pageData) {
      $scope.pageData = pageData || $scope.pageData;
      $scope.heatmapChart = Utils.getHeatmapChart($scope.pageData, $scope.config, $scope.stats, $scope.options, $scope.visibleMeasureIndex);
      var chartRows = $scope.heatmapChart.yAxis ? $scope.heatmapChart.yAxis.categories.length : 1;
      // add additional amount (estimated) to account for axis/label height
      var measureCount = $scope.config.measures.length;
      var estAxisLabelHeight = measureCount > 12 ? 250 : 100;
      $scope.chartHeight = 40 * chartRows + estAxisLabelHeight + 'px';
      $scope.chartWidth = measureCount > 12 ? measureCount * 100 + 'px' : null;
    };
    $scope.updateHeatmap = updateHeatmap;
    $scope.measures = $scope.config.measures;
    $scope.dimension = {
      name: AggUtils.getDimensionInSentence($scope.config.dimensions[0])
    };

    // Initialize the sortConfig
    var sortConfigOptions = {
      dimension: $scope.dimension,
      measures: $scope.measures,
      hiddenMeasures: $scope.config.hiddenMeasures
    };
    //need a way to deal with hidden measures here
    $scope.sortConfig = AggUtils.sortConfig(sortConfigOptions);
    $scope.sortConfig.setSelections($scope.config.defaultSort || $scope.sortConfig.defaultSort);
    $scope.sort = function (option, direction) {
      $scope.sortConfig.option = option;
      $scope.sortConfig.direction = direction;
      $scope.$broadcast(wsEventNames.pager.setPage, 1);
    };
    $scope.fetchPage = function (offset, limit) {
      offset = offset || 0;
      limit = limit || 10;
      $scope.fetchCfg = {
        cardId: $scope.cardId,
        cardToPreview: $scope.cardId === 'preview' ? $scope.card : null,
        params: {
          //"_limit": pageSize,
          "_limit": limit,
          "_offset": offset,
          "order_by": $scope.sortConfig.sortDirective()
        }
      };
      return Utils.fetchData($scope.fetchCfg).then(function (data) {
        var results = data.results[0].result;
        $scope.hasData = results.data.length > 0;
        $scope.pagenote.setReportMetadata(data);
        if ($scope.stats) {
          //the data stats are are only for the current page of data
          //since the heatmap colors are based on min and max this can be jarring based on data
          //so we are continuously updating this min and max as the user pages across data
          //alternativley, will use any configured min or max in the measure to override the stats
          _.each(results.stats, function (s, i) {
            var stat = $scope.stats[i];
            stat.min = Math.min(stat.min, s.min);
            stat.max = Math.max(stat.max, s.max);
          });
        } else {
          $scope.stats = results.stats;
        }
        $scope.pageData = results.data;
        updateHeatmap(results.data);
        return results;
      }, function () {
        $scope.hasData = false;
      });
    };
    $scope.toggleShowValues = function () {
      $scope.options.showValues = !$scope.options.showValues;
      updateHeatmap();
    };
    $scope.subDetails = [{
      text: "Download data",
      downloadData: true,
      tooltip: "Download data tables",
      href: CardQueryResource.getDownloadUrl('heatmap/csv', $scope.cardId, $scope.config)
    }, {
      text: "Download interaction statements",
      downloadData: true,
      tooltip: "Download interaction statements",
      callback: Utils.getStatementDownloadUrl($scope.cardId === 'preview' ? $scope.config : $scope.cardId)
    }];
    $scope.pagenote = {
      "clearCacheAction": "cards/" + $scope.cardId + "/cache"
    };
    $timeout(function () {
      $scope.$broadcast(wsEventNames.pager.setPage, 1);
    }, 0);
    CardUtils.setNavElements($scope, $scope.cardId, $scope.cardId);
  }]);
})();
